import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TelegramService {
  private telegramId: number | null = null;
  private initialized = false;

  constructor() {}

  /**
   * Get the current Telegram user ID if available
   */
  getTelegramId(): number | null {
    if (!this.initialized) {
      this.loadTelegramId();
    }
    return this.telegramId;
  }

  /**
   * Try to get the Telegram user ID from the WebApp context
   */
  private loadTelegramId(): void {
    this.initialized = true;

    try {
      const tg = (window as any).Telegram.WebApp;
      if (tg) {
        const initDataUnsafe = tg.initDataUnsafe;
        console.log({ tg });
        if (initDataUnsafe.user.id) {
          this.telegramId = initDataUnsafe.user.id;
        }
      }
    } catch (e) {
      console.error('Error accessing Telegram WebApp:', e);
    }
  }

  /**
   * Check if the app is running inside Telegram WebApp
   */
  isTelegramWebApp(): boolean {
    try {
      return !!(window as any).Telegram.WebApp;
    } catch (e) {
      return false;
    }
  }
}
